import { gql } from "lib/apolloClient";
import {
  courseRoutinePostFragment,
  routinePostFragment,
} from "./RoutineFragments";

export const getCourseRoutineTemplatesQuery = gql`
  query getCoursePostTemplate(
    $courseId: ID!
    $filters: CoursePostTemplateFilter
  ) {
    node(id: $courseId, type: COURSE) {
      ... on Course {
        id
        postTemplate(filters: $filters) {
          id
          type
          title
          isArchived
          isGlobal
        }
      }
      __typename
    }
  }
`;

export const getNodePostTemplateEntity = gql`
  query getNodePostTemplateEntity($id: ID!, $type: ENTITY_TYPE_ENUM!) {
    node(id: $id, type: $type) {
      id
      ... on PostTemplate {
        id
        title
        fields {
          id
          label
          placeholder
          type
          metadata
          displaySequence
          dataSets {
            title
            type
            id
            startDate
            endDate
            values {
              value
              item {
                id
                itemName
              }
              date
              displaySequence
              id
            }
          }
        }
      }

      ... on PostTemplateDataSet {
        id
        title
        updatedAt
        updatedBy {
          id
          firstName
          lastName
        }
        mappedTemplates {
          id
          title
        }
        values {
          id
          displaySequence
          value

          createdBy {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;

export const getCourseRoutinePostFeedQuery = gql`
  query getCourseRoutinesPostFeed(
    $id: ID!
    $after: String
    $filters: PostFilterInput
  ) {
    node(id: $id, type: COURSE) {
      id
      ... on Course {
        ...courseItem
      }
    }
  }
  ${courseRoutinePostFragment.courseRoutinePost}
`;

export const getStudentTemplateResponseQuery = gql`
  query getStudentTemplateResponse($id: [ID!]) {
    multiNode(ids: $id, type: STUDENT_TEMPLATE_RESPONSE) {
      ... on StudentTemplateResponse {
        id
        metadata
        student {
          id
        }
        fields {
          id
          value
          uid
          resolvedMinimalTree {
            id
            type
            ... on ResolvedFieldAttachmentGroup {
              attachmentGroups {
                id
                displaySequence
                metadata
                attachments {
                  id
                  type
                  signedUrl
                  url
                  displaySequence
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getRoutinePostDetailQuery = gql`
  query getRoutinePostDetail($id: ID!) {
    node(id: $id, type: POST) {
      id
      ... on Post {
        ...postItem
      }
    }
  }
  ${routinePostFragment.routinePostDetail}
`;
